



































































import {Vue, Component, Watch} from 'vue-property-decorator'
import {ServisnaOperacija} from "@/services/BackendProxies";
import dataProxy from "@/services/data-proxy.service"
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class ServisneOperacije extends mixins(ComponentBaseMixin) {
    columns = [];
    servisneOperacije = [];
    servisnaOperacija = new ServisnaOperacija();
    grupeDelova = [];
    tableOptions = {
        search: true,
        pagination: true,
        onClickRow: row => this.onClickRow(row)
    };

    textVrstaOdrzavanja = '';

    async created() {
        this.columns = [
            {field: 'naziv', width: 230, title: this.$i18n.t('naziv')},
            {field: 'grupaDelovaVozila', width: 120, title: this.$i18n.t('grupaDelova')},
            {field: 'vrstaOdrzavanja', width: 20, title: 'P/C'},
        ];
        this.servisneOperacije = await this.loadData(() => dataProxy.vratiServisneOperacije())();
        this.grupeDelova = await this.loadData(() => dataProxy.vratiGrupeDelovaVozila())();
    }

    sklopChange(grupaDelovaVozilaId) {
        if (grupaDelovaVozilaId) {
            const deoVozila = this.grupeDelova.find(x => x.id == grupaDelovaVozilaId);
            if (deoVozila) {
                this.servisnaOperacija.grupaDelovaVozila = `${deoVozila.oznaka} ${deoVozila.naziv}`;
            }
        } else {
            this.servisnaOperacija.grupaDelovaVozila = '';
            this.textVrstaOdrzavanja = '';
        }
    }

    async sacuvajServisnuOperaciju() {
        const isValidForm = await (<any>this.$refs.form).validate();
        if (isValidForm) {
            this.servisnaOperacija = await this.saveData(() => dataProxy.sacuvajServisnuOperaciju(this.servisnaOperacija))();
            this.servisneOperacije = await this.loadData(() => dataProxy.vratiServisneOperacije())();
        }
    }

    async obrisiServisnuOperaciju() {
        const isValid = await this.confirmationNeeded('da li zelite da obrisete servisnu operaciju');
        if (isValid) {
            this.servisneOperacije = await this.deleteData(() => dataProxy.obrisiServisnuOperacaiju(this.servisnaOperacija.id))();
            this.novaServisnaOperacija();
        }
    }

    novaServisnaOperacija() {
        this.servisnaOperacija = new ServisnaOperacija();
        (<HTMLElement>this.$refs.naziv).focus();
    }

    onClickRow(row) {
        this.servisnaOperacija = row;
    }
}
